import mean from 'lodash/mean';
import type { PurchasesList } from '../../libs/offerSystem/OfferSystemHistory';
import { MS_IN_DAY } from '../../utils/time-utils';

const averagePurchaseDays = 60;

const spendingBands = [748, 1450, 2950, 4950, 6950, Infinity];

export function calculateSpendingBand(purchaseList: PurchasesList): number {
  const recentPurchaseHistory = purchaseList.filter(
    (entry) => (Date.now() - entry.date) / MS_IN_DAY < averagePurchaseDays,
  );
  const meanSpending =
    recentPurchaseHistory.length > 0 ? mean(recentPurchaseHistory.map((entry) => entry.usdCentPrice)) : 0;

  if (meanSpending === 0) return 0;
  return spendingBands.findIndex((bandRange) => meanSpending <= bandRange) + 1;
}
